import { ResponsiveTable } from './components/common/ResponsiveTable';
import React, { useEffect, useState } from 'react';
import { AllergyApi, Allergy, PatientAllergy } from './allergies';

interface Props { patientId: number; token: string; }

export default function AllergyManagement({ patientId, token }: Props) {
  const [catalog, setCatalog] = useState<Allergy[]>([]);
  const [patientAllergies, setPatientAllergies] = useState<PatientAllergy[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedAdd, setSelectedAdd] = useState('');

  const load = () => {
    setLoading(true);
    Promise.all([
      AllergyApi.listCatalog(token),
      AllergyApi.listForPatient(token, patientId)
    ])
      .then(([c, pa]) => { setCatalog(c); setPatientAllergies(pa); })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  };

  // Reload when patient/token changes; keeping `load` local avoids stale closures.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [patientId, token]);

  const handleAdd = async () => {
    if (!selectedAdd) return;
    setError('');
    try { await AllergyApi.addToPatient(token, patientId, Number(selectedAdd)); load(); setSelectedAdd(''); }
    catch (e: any) { setError(e.message); }
  };

  const handleRemove = async (id: number) => {
    if (!window.confirm('Remove this allergy?')) return;
    setError('');
    try { await AllergyApi.removeFromPatient(token, patientId, id); load(); }
    catch (e: any) { setError(e.message); }
  };

  if (loading) return <div>Loading allergies...</div>;
  return (
    <div style={{marginTop:32}}>
      <h3>Allergies</h3>
      {error && <div style={{color:'red'}}>{error}</div>}
      <div className="responsive-row" style={{display:'flex',gap:8,alignItems:'center',marginBottom:12}}>
        <select value={selectedAdd} onChange={e => setSelectedAdd(e.target.value)}>
          <option value=''>Add allergy...</option>
          {catalog.filter(c => !patientAllergies.some(pa => pa.id === c.id)).map(a => (
            <option key={a.id} value={a.id}>{a.name} ({a.dangerLevel})</option>
          ))}
        </select>
        <button onClick={handleAdd} disabled={!selectedAdd}>Add</button>
      </div>
      {patientAllergies.length === 0 ? <div>No patient allergies.</div> : (
        <ResponsiveTable><table style={{borderCollapse:'collapse',width:'100%'}}>
          <thead>
            <tr style={{background:'#1976d2',color:'white'}}>
              <th style={{padding:6}}>Name</th>
              <th style={{padding:6}}>Danger</th>
              <th style={{padding:6}}>Medications</th>
              <th style={{padding:6}}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {patientAllergies.map(a => (
              <tr key={a.id}>
                <td style={{padding:6}}>{a.name}</td>
                <td style={{padding:6}}>{a.dangerLevel}</td>
                <td style={{padding:6}}>{a.medications?.join(', ') || '-'}</td>
                <td style={{padding:6}}><button onClick={() => handleRemove(a.id)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table></ResponsiveTable>
      )}
    </div>
  );
}
